<template>
    <div class="main-wrapper">
        <Layout>
            <common-header></common-header>
            <keep-alive>
                <router-view name="content"></router-view>
            </keep-alive>
            <common-footer></common-footer>
        </Layout>
    </div>
</template>

<script>
    import commonHeader from '../../components/header/commonHeader'
    import commonFooter from '../../components/footer/commonFooter'
    export default {
        name: "index.vue",
        components: {
            commonHeader,
            commonFooter
        },
    }
</script>

<style scoped>

    .main-wrapper {
        background-color: #fff;
        width: 100%;
        margin: 0 auto
    }

</style>